<template>
	<div>
		<BaseLoading
			v-if="isLoadingDetail"
		/>
		<template
			v-else
		>
			<!-- Head of General Information -->
			<CRow>
				<CCol xl="9">
					<p class="text-header d-flex align-items-center">
						SKU: {{ detailInfo.sku }}
						<CBadge
							:color="status.color"
							class="badge-status ml-3"
						>
							{{ status.title }}
						</CBadge>
					</p>
				</CCol>
				<CCol
					v-if="isAddStockAllowed"
					xl="3"
				>
					<div class="d-flex justify-content-end">
						<CButton
							class="btn-change-password flex transparent btn-export-csv"
							color="primary"
							@click="handleModalConfirm"
						>
							Add stock 77
						</CButton>
					</div>
				</CCol>
			</CRow>
			<!-- End Head of General Information -->

			<!-- General Information -->
			<div class="container-general">
				<div class="container-general-image">
					<img
						:src="detailInfo.imageOriginal || '/img/product-placeholder.svg'"
					>
				</div>
				<div class="container-general-info ml-4">
					<CRow>
						<CCol xl="12">
							<div class="d-flex align-items-baseline">
								<p>
									<span class="text-label">
										Product Name:
									</span>
								</p>
								<div class="d-flex flex-column ml-2">
									<p class="text-desc">
										{{ detailInfo.productName }}
									</p>
								</div>
							</div>
						</CCol>
						<CCol xl="12">
							<div class="d-flex align-items-baseline">
								<p>
									<span class="text-label">
										Category:
									</span>
								</p>
								<div class="d-flex flex-wrap ml-2">
									<p
										v-for="(value, index) in detailInfo.categories"
										:key="index"
										class="category-list mb-0 text-desc"
									>
										{{ value }}
									</p>
								</div>
							</div>
						</CCol>
					</CRow>
					<CRow>
						<CCol xl="6">
							<div
								:class="`${detailInfo.onlineStockRule.length ? '' : 'd-flex align-items-baseline'}`"
							>
								<p class="mb-1">
									<span class="text-label">
										Online stock rule:
									</span>
								</p>
								<div
									:class="`${detailInfo.onlineStockRule.length ? '' : 'd-flex flex-column ml-2'}`"
								>
									<div
										v-if="detailInfo.onlineStockRule.length"
										class="container-text-box mb-3"
									>
										<p
											v-for="onlineStockRule in detailInfo.onlineStockRule"
											:key="onlineStockRule.id"
											class="text-desc d-flex align-items-center"
										>
											<CBadge
												class="badge-status rule"
												:color="onlineStockRule.status ? CBADGE_COLORS.SUCCESS : CBADGE_COLORS.DANGER"
											>
												{{ onlineStockRule.status ? $t('message.active') : $t('message.inactive') }}
											</CBadge>
											<span class="default-value-dat">
												{{ onlineStockRule.name }} (priority {{ onlineStockRule.priority }})
											</span>
										</p>
									</div>
									<span v-else>-</span>
								</div>
							</div>
						</CCol>
						<CCol xl="6">
							<div
								:class="`${detailInfo.channelRule.length ? '' : 'd-flex align-items-baseline'}`"
							>
								<p class="mb-1">
									<span class="text-label">
										Channel rule:
									</span>
								</p>
								<div
									:class="`${detailInfo.channelRule.length ? '' : 'd-flex flex-column ml-2'}`"
								>
									<div
										v-if="detailInfo.channelRule.length"
										class="container-text-box mb-3"
									>
										<p
											v-for="channelRule in detailInfo.channelRule"
											:key="channelRule.id"
											class="text-desc d-flex align-items-center"
										>
											<CBadge
												class="badge-status rule"
												:color="channelRule.status ? CBADGE_COLORS.SUCCESS : CBADGE_COLORS.DANGER"
											>
												{{ channelRule.status ? $t('message.active') : $t('message.inactive') }}
											</CBadge>
											<span class="default-value-dat">
												{{ channelRule.name }} (priority {{ channelRule.priority }})
											</span>
										</p>
									</div>
									<span v-else>-</span>
								</div>
							</div>
						</CCol>
					</CRow>
					<CRow>
						<CCol xl="12" class="pt-2">
							<CRow>
								<CCol xl="3">
									<CRow>
										<CCol xl="12">
											<p class="text-label m-0">
												Brand:
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.brand }}
											</p>
										</CCol>
										<CCol xl="12">
											<p class="text-label m-0">
												Product type:
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.productType }}
											</p>
										</CCol>
									</CRow>
								</CCol>
								<CCol xl="3">
									<CRow>
										<CCol xl="12">
											<p class="text-label m-0">
												SRP price:
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.srpPrice }}
											</p>
										</CCol>
										<CCol xl="12">
											<p class="text-label m-0">
												Minimum price:
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.minPrice }}
											</p>
										</CCol>
									</CRow>
								</CCol>
								<CCol xl="3">
									<CRow>
										<CCol xl="12">
											<p class="text-label m-0">
												All Stock (QTY):
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.totalStock }}
											</p>
										</CCol>
										<CCol xl="12">
											<p class="text-label m-0">
												Online stock
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.onlineStock }}
											</p>
										</CCol>
										<CCol xl="12">
											<p class="text-label m-0">
												Offline stock
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.offlineStock }}
											</p>
										</CCol>
									</CRow>
								</CCol>
								<CCol xl="3">
									<CRow>
										<CCol xl="12">
											<p class="text-label m-0">
												SKU details last synced:
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.skuLastSynced }}
											</p>
										</CCol>
										<CCol xl="12">
											<p class="text-label m-0">
												Stock last synced:
											</p>
											<p class="text-desc mb-2">
												{{ detailInfo.stockLastSynced }}
											</p>
										</CCol>
									</CRow>
								</CCol>
							</CRow>
						</CCol>
					</CRow>
				</div>
			</div>
			<!-- End General Information -->
		</template>

		<!-- Head of Table -->
		<CRow>
			<CCol xl="12">
				<p class="text-header">
					Available in branch
				</p>
			</CCol>
		</CRow>
		<!-- End Head of Table -->

		<!-- Filter -->
		<BaseSearchFilter
			:active="isActive"
			:show="isActive"
		>
			<template #header>
				<CCol>
					<CInput
						v-model="query.keyword"
						:placeholder="$t('placeholder.stock_browser_sku_detail')"
						@keyup.enter="onInputEnter"
					>
						<template #prepend-content>
							<FontAwesomeIcon :icon="['far', 'search']" />
						</template>
					</CInput>
				</CCol>
			</template>
			<template #body>
				<CCol md="3">
					<BaseDropDown
						v-model="filter.location"
						:options="locationOptions"
						:label-drop-down="$t('label.location')"
						:placeholder="$t('message.selection')"
						:searchable="true"
						label="name"
						track-by="value"
						@input="handleLocationChange"
					/>
				</CCol>
				<CCol md="6">
					<CRow>
						<CCol md="3" class="m-0 p-0">
							<BaseDropDown
								v-model="filter.viewby"
								:options="viewbyOptions"
								:label-drop-down="$t('label.view_stock_qty')"
								:placeholder="$t('message.selection')"
								:searchable="true"
								label="name"
								track-by="value"
								@input="handleViewbyChange"
							/>
						</CCol>
						<CCol md="2" class="m-0 p-0 min">
							<label>
								Min
							</label>
							<CInput
								v-model="query.min"
								placeholder="Min qty"
								text-align="left"
								@keyup.enter="onInputEnterMin"
							/>
						</CCol>
						<CCol md="2" class="m-0 p-0 max">
							<label>
								Max
							</label>
							<CInput
								v-model="query.max"
								placeholder="Max qty"
								text-align="left"
								@keyup.enter="onInputEnterMax"
							/>
						</CCol>
					</CRow>
				</CCol>
			</template>
			<template #footer>
				<CCol md="8">
					{{ $t('message.branches_found', { number: totalCount }) }}
				</CCol>
				<CCol md="4">
					<button @click="onResetClick">
						{{ $t('button.resetFilters') }}
					</button>
				</CCol>
			</template>
		</BaseSearchFilter>
		<!-- End Filter -->

		<!-- Table, Pagination -->
		<CRow>
			<CCol xl="12">
				<BaseTable
					:is-loading="isLoadingTable"
					:pagination="pagination"
					:fields="STOCK_BROWSER_SKU_DETAIL_TABLE_FIELDS"
					:items="dataTable"
					:hide-columns="['id']"
					:sort-columns="{
						branch_id: query.sort_by === 'branch_id' ? (query.sort_direction || 'asc') : 'asc',
						branch_name: query.sort_by === 'branch_name' ? (query.sort_direction || 'asc') : 'asc',
						online_stock_quantity: query.sort_by === 'online_stock_quantity' ? (query.sort_direction || 'asc') : 'asc',
						offline_stock_quantity: query.sort_by === 'offline_stock_quantity' ? (query.sort_direction || 'asc') : 'asc',
						total_stock_quantity: query.sort_by === 'total_stock_quantity' ? (query.sort_direction || 'asc') : 'asc',
					}"
					hover
					fixed
					class="table-custom"
					@onSortClick="handleSortClick"
					@onPaginationClick="handlePageClick"
				>
					<template #no-items-view>
						<div class="empty-table-element">
							<p class="subtitle">
								{{ $t('message.notFoundSkuList') }}
							</p>
						</div>
					</template>
					<template #image="{ item = '' }">
						<img
							:src="item || '/img/product-placeholder.svg'"
							width="40"
							height="40"
						>
					</template>
					<template #category="{ item = '' }">
						<p
							v-for="(value, index) in item"
							:key="index"
							class="m-2"
						>
							{{ value }}
						</p>
					</template>
				</BaseTable>
			</CCol>
		</CRow>
		<!-- End Table, Pagination -->
		<BaseModalConfirm
			ref="modal-confirm"
			title="Add stock to branch 77"
			description="Are you sure you want to add this product's stock to branch 77?"
			primary-button-text="OK"
			@onConfirm="handleAddStockITEC"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { randomSearchString, cleanObject, cloneDeep, numberFormat } from '../helpers/utils';
import { getSelectedValue } from '../helpers/dropdown';
import { STOCK_BROWSER_SKU_DETAIL_TABLE_FIELDS } from '../enums/stock';
import { SKU_STATUS_COLOR, SKU_STATUS_TITLE } from '../enums/sku';
import { CBADGE_COLORS } from '../enums/cbadgeColors';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'StockBrowserSkuSingle',

	data() {
		return {
			STOCK_BROWSER_SKU_DETAIL_TABLE_FIELDS,
			CBADGE_COLORS,
			query: {
				keyword: this.$route.query.keyword || null,
				location: this.$route.query.location || null,
				viewby: this.$route.query.viewby || null,
				min: this.$route.query.min || null,
				max: this.$route.query.max || null,
				sort_by: this.$route.query.sort_by || null,
				sort_direction: this.$route.query.sort_direction || null,
				page: this.$route.query.page || null,
				r: randomSearchString(),
			},
			filter: {
				location: getSelectedValue(null, this.locationOptions),
				viewby: getSelectedValue(null, this.viewbyOptions),
				min: this.$route.query.min,
				max: this.$route.query.max,
			},
		};
	},

	computed: {
		...mapState('stockBrowserSkuSingle', {
			detailInfo: 'data',
			isLoadingDetail: 'isLoading',
		}),
		...mapState('stockBrowserSkuBranchList', {
			branchList: 'data',
			isLoadingTable: 'isLoading',
			pagination: 'pagination',
		}),
		...mapGetters('locationList', {
			locationOptions: 'locationOptions',
		}),
		dataTable() {
			return this.branchList.map((item) => {
				return {
					id: item.itecBranchId,
					branch_id: item.itecBranchId,
					branch_name: item.branchName,
					online_stock_quantity: item.onlineStock,
					offline_stock_quantity: item.offlineStock,
					total_stock_quantity: item.totalStock,
					location: item.location,
				};
			});
		},
		totalCount() {
			return numberFormat(this.pagination.total);
		},
		status() {
			return {
				title: SKU_STATUS_TITLE[this.detailInfo.status],
				color: SKU_STATUS_COLOR[this.detailInfo.status],
			};
		},
		viewbyOptions() {
			return [
				{
					name: 'All stock',
					value: null,
				},
				{
					name: 'Online stock qty',
					value: 'online_stock_quantity',
				},
				{
					name: 'Offline stock qty',
					value: 'offline_stock_quantity',
				},
				{
					name: 'Total stock qty',
					value: 'total_stock_quantity',
				},
			];
		},
		// check any dropdowns are activated
		isActive() {
			if (this.filter.location?.value !== null) return true;
			if (this.filter.viewby?.value !== null) return true;
			if (this.filter.min !== undefined) return true;
			if (this.filter.max !== undefined) return true;

			return false;
		},
		isAddStockAllowed() {
			return this.detailInfo.isAddStockAllowed;
		},
	},

	async created() {
		await this.fetchData();

		// set page title
		this.setPageTitle({
			title: this.detailInfo.sku,
			isShow: true,
		});

		// we have to clear old the breadcrumbs first
		this.clearBreadcrumb({ startAtIndex: 1 });
		// then add new breadcrumb
		this.addBreadcrumb({
			title: this.detailInfo.sku,
			route: {
				name: ROUTER_NAME.STOCK_BROWSER_SKU_SINGLE,
				params: { id: this.$route.params.id },
			},
		});

		this.filter.location = getSelectedValue(this.$route.query.location
			? parseInt(this.$route.query.location, 10)
			: null, this.locationOptions);

		this.filter.viewby = getSelectedValue(this.$route.query.viewby
			? this.$route.query.viewby
			: null, this.viewbyOptions);
	},

	methods: {
		...mapActions('stockBrowserSkuSingle', {
			getProductStockSkuDetail: 'getProductStockSkuDetail',
			postProductStock: 'postProductStock',
		}),
		...mapActions('stockBrowserSkuBranchList', {
			getProductStockSkuBranches: 'getProductStockSkuBranches',
		}),
		...mapActions('pageTitle', {
			setPageTitle: 'setPageTitle',
		}),
		...mapActions('breadcrumb', {
			addBreadcrumb: 'addBreadcrumb',
			clearBreadcrumb: 'clearBreadcrumb',
		}),
		...mapActions('locationList', {
			getLocations: 'getLocations',
		}),
		async fetchData() {
			const list = [];
			const isLoadedDetail = (
				this.query.keyword ||
				this.query.page ||
				this.query.sort_by ||
				this.query.location ||
				this.query.viewby ||
				this.query.min ||
				this.query.max
			) && this.detailInfo.sku;
			const isLoadedLocations = this.locationOptions.length > 1;

			if (!isLoadedDetail) {
				list.push(this.getProductStockSkuDetail({ id: this.$route.params.id }));
			}

			if (!isLoadedLocations) {
				list.push(this.getLocations());
			}

			await Promise.all([
				...list,
				this.getProductStockSkuBranches({ id: this.$route.params.id, params: this.query }),
			]);
		},
		onInputEnter(e) {
			this.query.keyword = e.target.value;
			this.query.page = null;
			this.updateUrl();
		},
		handleSortClick(key = '', state = false) {
			this.query.page = null;
			this.query.sort_by = key;
			this.query.sort_direction = state;
			this.updateUrl();
		},
		handlePageClick(pageNum) {
			this.query.page = pageNum;
			this.updateUrl();
		},
		updateUrl() {
			const query = cleanObject({
				// always put tab, page queries to the `newQuery`
				tab: this.$route.query.tab,
				...cloneDeep(this.query),
			});
			this.$router.push({ query }).catch(() => {});
		},
		onResetClick() {
			this.query.keyword = null;
			this.query.location = null;
			this.query.viewby = null;
			this.query.min = null;
			this.query.max = null;
			this.query.sort_by = null;
			this.query.sort_direction = null;
			this.query.page = null;
			this.query.r = null;
			this.updateUrl();
		},
		handleLocationChange(option) {
			this.query.location = option?.value;
			this.query.page = null;
			this.updateUrl();
		},
		handleViewbyChange(option) {
			this.query.viewby = option?.value;
		},
		onInputEnterMin(e) {
			this.query.min = e.target.value;
			this.query.page = null;
			this.updateUrl();
		},
		onInputEnterMax(e) {
			this.query.max = e.target.value;
			this.query.page = null;
			this.updateUrl();
		},
		handleModalConfirm() {
			this.$refs['modal-confirm'].open();
		},
		async handleAddStockITEC() {
			await this.postProductStock({
				itec_branch_id: 77,
				product_id: this.$route.params.id,
			});
			await this.fetchData();
		},
	},
};
</script>

<style lang="scss" scoped>
.container-general {
	display: flex;

	&-image {
		width: rem(132);

		img {
			width: rem(132);
			height: rem(132);
		}
	}
}

.container-text-box {
	padding: rem(8) rem(16);
	background-color: $color-gray-100;
	border-radius: rem(4);

	p {
		margin-bottom: rem(4);

		&:last-of-type {
			margin-bottom: 0;
		}
	}
}

.badge-status {
	@include typo-bullet-2;

	color: $color-white;

	&.rule {
		font-size: rem(9);
		margin-right: 6px;
	}
}

::v-deep .table-custom {
	margin-top: rem(32);

	.branch-id {
		// .branch-id-col
		&-col {
			min-width: rem(120 + $table-cell-padding);
		}
	}

	.branch-name {
		// .branch-name-col
		&-col {
			min-width: rem(180 + $table-cell-padding);
		}
	}

	.available-stock, .branch-self-stock {
		// .available-stock-col, .branch-self-stock-col
		&-col {
			min-width: rem(150 + $table-cell-padding);
		}
	}

	.location {
		// .location-col
		&-col {
			min-width: rem(150 + $table-cell-padding);
		}
	}
}

::v-deep .min input {
	border-radius: 0;
	position: relative;
	left: rem(-5);
	height: rem(34);

	&:focus {
		z-index: 1;
	}
}

::v-deep .max input {
	border-radius: 0 4px 4px 0;
	position: relative;
	left: rem(-6);
	height: rem(34);

	&:focus {
		z-index: 1;
	}
}

.category-list {
	background-color: $color-alto;
	border-radius: rem(4);
	color: $color-black-45;
	padding: 0 rem(4);
	margin: rem(4);
	width: max-content;
}
</style>
